import type { HttpTransport } from '@mangovoice/api-client'

/**
 * User Groups resource - delegates to the @mangovoice/user-groups-ui library
 * for actual endpoint definitions. This provides a pass-through transport adapter.
 */
export function createUserGroupsResource(transport: HttpTransport) {
  return {
    get: <T>(url: string, params?: Record<string, unknown>) =>
      transport.get<T>(url, params),

    post: <T>(url: string, data?: unknown) => transport.post<T>(url, data),

    put: <T>(url: string, data?: unknown) => transport.put<T>(url, data),

    patch: <T>(url: string, data?: unknown) => transport.patch<T>(url, data),

    delete: <T>(url: string) => transport.delete<T>(url),
  }
}
